import styled from 'styled-components'

export const Title = styled.span`
    font-weight: 900;
    font-size: 13px;
    white-space: nowrap;
    border-bottom: 1px solid rgba(151, 151, 151, 0.18);
    padding: 24px 24px 19px 24px;
    width: 100%;
    display: inline-block;

    @media (max-width: 768px) {
        flex-grow: 0;
    }
`

export const List = styled.div`
    max-height: 470px;
    overflow-y: auto;

    @media (max-width: 768px) {
        flex-grow: 1;
        max-height: 100%;
    }

    & + & {
        padding-top: 0;
    }
`
